import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reset } from 'redux-form';
import NewUserForm from '../components/NewUserForm';
import { createUser, getUsersApiOptions } from '../actions/users';
import {
  getSubmitStatus,
  getNewUserSubmitSucceeded,
  getNewUserId,
  getNewUserEmailStatus,
  getNewUserPhoneStatus,
  getIncludedInGroups,
} from '../reducers';
import { Redirect } from 'react-router-dom';
import { businessChildAclGroups, resellerChildAclGroups } from '../helpers/user';

class CreateUser extends Component {
  state = {
    resellerUserTypes: [],
  };

  componentDidMount () {
    const { isReseller, isAdmin, resetForm } = this.props;
    if (!isReseller && !isAdmin) {
      return;
    }

    resetForm('newUser');
    resetForm('address');

    getUsersApiOptions().then((res) => {
      const excludedChoices = [...businessChildAclGroups, ...resellerChildAclGroups];
      if (res.error) {
        return;
      }

      const { choices } = res.acl_group_name;
      const filteredChoices = choices.filter((choice) => {return !excludedChoices.includes(choice.value)});
      this.setState({
        resellerUserTypes: filteredChoices.map(({ value }) => [value, value]),
      });
    });
  }

  render () {
    const { isReseller, isAdmin, isBusiness } = this.props;
    if (isBusiness) {
      return <Redirect to='/' />;
    }
    return (
      <NewUserForm
        {...this.props}
        isAdmin={isAdmin}
        isReseller={isReseller}
        resellerUserTypes={this.state.resellerUserTypes}
      />
    );
  }
}

const mapStateToProps = (state) => ({
  saveStatus: getSubmitStatus(state, 'newUser'),
  submitSucceeded: getNewUserSubmitSucceeded(state),
  userId: getNewUserId(state),
  isEmail: getNewUserEmailStatus(state),
  isPhone: getNewUserPhoneStatus(state),
  isReseller: getIncludedInGroups(state, ['RESELLER']),
  isBusiness: getIncludedInGroups(state, ['BUSINESS']),
  isAdmin: getIncludedInGroups(state, ['ADMIN']),
});

const mapDispatchToProps = {
  onSubmit: createUser,
  resetForm: reset,
};

const CreateUserConnected = connect(
  mapStateToProps,
  mapDispatchToProps,
)(CreateUser);

export default CreateUserConnected;
